import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

interface Validation {
  text: string;
  validated: boolean;
}

interface ValidationsProps {
  validations: Validation[];
}

const Validations: React.FC<ValidationsProps> = ({ validations }) => {
  return (
    <ValidationsList>
      {validations.map(({ text, validated }) => {
        const validationClassName = classNames({
          success: validated,
        });
        return (
          <ValidationListItem key={text}>
            <ValidationIcon className={validationClassName}>
              {validated ? '✔ ' : '✖ '}
            </ValidationIcon>
            {text}
          </ValidationListItem>
        );
      })}
    </ValidationsList>
  );
};

export default Validations;

const ValidationsList = styled.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;
`;

const ValidationListItem = styled.li`
  font-size: 12px;
`;

const ValidationIcon = styled.span`
  color: #a02015;

  &.success {
    color: green;
  }
`;
